import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";
const path =
  "M17.0019 2.98499C16.5119 2.49499 15.7219 2.49499 15.2319 2.98499L6.92189 11.295C6.53189 11.685 6.53189 12.315 6.92189 12.705L15.2319 21.015C15.7219 21.505 16.5119 21.505 17.0019 21.015C17.4919 20.525 17.4919 19.735 17.0019 19.245L9.76189 11.995L17.0119 4.74499C17.4919 4.26499 17.4919 3.46499 17.0019 2.98499Z";

export default function LeftChevron(props: IconProps) {
  return <SVGIcon path={path} {...props} />;
}
